import React from "react"
import { Link } from "react-router-dom"

export default function Button({
  children,
  to,
  href,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  className = "",
  ariaLabel,
}) {
  const baseStyles =
    "inline-flex items-center justify-center rounded-full font-medium tracking-wide transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2"

  const variants = {
    primary:
      "bg-[#b8955d] text-white hover:bg-[#9f7d48] focus:ring-[#b8955d] shadow-md",

    secondary:
      "bg-white text-[#111111] border border-[#b8955d] hover:bg-[#b8955d] hover:text-white focus:ring-[#b8955d]",

    dark:
      "bg-[#111111] text-white hover:bg-black focus:ring-black",

    outline:
      "border border-white text-white hover:bg-white hover:text-[#111111] focus:ring-white",
  }

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-sm md:text-base",
    lg: "px-8 py-4 text-base md:text-lg",
  }

  const widthClass = fullWidth ? "w-full" : ""

  const disabledStyles = disabled
    ? "opacity-50 cursor-not-allowed pointer-events-none"
    : ""

  const buttonClasses = `
    ${baseStyles}
    ${variants[variant]}
    ${sizes[size]}
    ${widthClass}
    ${disabledStyles}
    ${className}
  `

  // External Link
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClasses}
        aria-label={ariaLabel}
      >
        {children}
      </a>
    )
  }

  // Internal Link
  if (to) {
    return (
      <Link
        to={to}
        className={buttonClasses}
        aria-label={ariaLabel}
      >
        {children}
      </Link>
    )
  }

  // Normal Button
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  )
}